import { useEffect } from 'react';

/**
 * Loads Tawk.to chat widget when REACT_APP_TAWK_PROPERTY_ID and REACT_APP_TAWK_WIDGET_ID
 * are set in .env. Switch env block (local / dev / staging / live) to change which
 * property's widget loads.
 */
export function TawkWidget() {
	useEffect(() => {
		const propertyId = process.env.REACT_APP_TAWK_PROPERTY_ID?.trim();
		const widgetId = process.env.REACT_APP_TAWK_WIDGET_ID?.trim();

		const isPlaceholder = (v: string) => v.startsWith('your_');
		if (!propertyId || !widgetId || isPlaceholder(propertyId) || isPlaceholder(widgetId)) return;
		if (document.getElementById('tawk-script')) return;

		(window as unknown as { Tawk_API?: unknown }).Tawk_API = (window as unknown as { Tawk_API?: unknown }).Tawk_API || {};
		(window as unknown as { Tawk_LoadStart?: Date }).Tawk_LoadStart = new Date();

		const script = document.createElement('script');
		script.id = 'tawk-script';
		script.async = true;
		script.src = `https://embed.tawk.to/${propertyId}/${widgetId}`;
		script.charset = 'UTF-8';
		script.setAttribute('crossorigin', '*');

		const firstScript = document.getElementsByTagName('script')[0];
		if (firstScript?.parentNode) {
			firstScript.parentNode.insertBefore(script, firstScript);
		}
	}, []);

	return null;
}
